<template>
  <div class="">
    <!-- header start -->
    <van-nav-bar 
      title="时空信箱" 
      left-arrow 
      fixed 
      :z-index="99" 
      @click-left="onClickLeft" 
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore"
      >
      <div>
        <div class="mainbox-list van-hairline--bottom" v-for="item in dataList" :key="item.HallCommentMainID">
          <div class="mainbox-header">
            <div class="hd">
              <van-image
                round
                width="100%"
                height="100%"
                fit="cover"
                :src="item.MemberApiModel.HeadPic"
              />
            </div>
            <div class="bd">
              <div class="name">{{item.MemberApiModel.NickName}}</div>
              <p class="date">发布时间：{{$moment(item.AddDateTime).format('YYYY-MM-DD')}}</p>
              <div class="mall">纪念馆：{{item.MemorialTitle}}</div>
            </div>
            <div class="ft">
              <van-button round color="orange" size="small" :to="{path:'/MemorialHall?id='+item.MemorialSerialNumber}" >进入纪念馆</van-button>
            </div>
          </div>
          <div class="mainbox-body">
            <!-- <div class="text-box">哈利·波特》系列发布多张壁纸，供宅在家里的网友开视频会议用，有线上魔法课教学的感觉不？啥时候去霍格沃茨上课</div> -->
            <div v-html="item.Content" class="text-box rich"></div>
            <div class="image-box">
              <van-row gutter="5">
                <van-col span="8" v-for="(clientitem,index) in item.HallCommentMainPhonePhotoList" :key="clientitem.Id" @click="preview(item.HallCommentMainPhonePhotoList,index)">
                  <div class="image"><van-image fit="cover" :src="clientitem.PhotoPath" /></div>
                </van-col>
              </van-row>
            </div>
          </div>
          
          <CommentBox  
            :id="item.HallCommentMainID"
            :memorialHallID="item.MemorialHallID"
            :hallCommentMainID="item.HallCommentMainID"
            :replyList.sync="item.HallCommentReplyList" 
            :isPraise.sync="item.IsPraise"
            :praiseCount.sync="item.PraiseCount"
            />
        </div>
      </div>

      </van-list>
    </van-pull-refresh>
    <!-- <div>
      <div class="mainbox-list van-hairline--bottom" v-for="item in 2" :key="item.id">
        <div class="mainbox-header">
          <div class="hd">
            <van-image
              round
              width="100%"
              height="100%"
              fit="cover"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </div>
          <div class="bd">
            <div class="name">张三</div>
            <p class="date">发布时间：2020-04-01</p>
            <div class="mall">纪念馆：张三纪念馆</div>
          </div>
          <div class="ft">
            <van-button round color="orange" size="small">进入纪念馆</van-button>
          </div>
        </div>
        <div class="mainbox-body">
          <div class="text-box">哈利·波特》系列发布多张壁纸，供宅在家里的网友开视频会议用，有线上魔法课教学的感觉不？啥时候去霍格沃茨上课</div>
          <div class="image-box">
            <van-row gutter="5">
              <van-col span="8" v-for="item in 6" :key="item.id" @click="preview(item.index)">
                <div class="image"><van-image fit="cover" src="https://img.yzcdn.cn/vant/cat.jpeg" /></div>
              </van-col>
            </van-row>
          </div>
        </div>
        <CommentBox />
      </div>
    </div> -->

  </div>
</template>

<script>
  import CommentBox from '@/components/CommentBox.vue';
  import { ImagePreview, Toast } from 'vant';
  import { mapGetters } from "vuex";

	export default {
	  data() {
	    return {
        refreshing: false,
        loading: true,
        finished: false,
        offset: 100,
        ischeck: false,
        options: null,
        dataList: []
	    };
    },
    computed: {
      ...mapGetters(["currentToken"])
    },
	  components: {
      CommentBox
    },
    mounted() {
      document.querySelector('body').removeAttribute('style')
    },
    methods: {
      onClickLeft() {
        this.$router.go(-1)
      },
      preview(photolist,index) {
        var plist = [];
        if (photolist){
          for(var i=0; i< photolist.length; i++){
            plist[i] = photolist[i].PhotoPath;
          }
        }
        ImagePreview({
          // images: [
          //   'https://img.yzcdn.cn/vant/cat.jpeg',
          //   'https://img.yzcdn.cn/vant/cat.jpeg',
          //   'https://img.yzcdn.cn/vant/cat.jpeg',
          //   'https://img.yzcdn.cn/vant/cat.jpeg',
          //   'https://img.yzcdn.cn/vant/cat.jpeg',
          //   'https://img.yzcdn.cn/vant/cat.jpeg',
          // ],
          images: plist,
          startPosition: index,
          closeable: true,
        });
      },
      init() {
      var that = this;
      that.options = {
        type: "getMailBoxList",
        pageIndex: 1
      };
      that.getList();
    },
    loadMore() {
      Object.assign(this.options, {
        pageIndex: this.options.pageIndex + 1
      });
      this.loading = true;
      this.getList();
    },
    onRefresh() {
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      Object.assign(this.options, {
        pageIndex: 1
      });
      this.getList();
    },
    getList() {
      var that = this;
      this.$store.dispatch(this.options).then(
        res => {
          that.loading = false;
          if (that.refreshing) {
            that.refreshing = false;
          }
          var dataList = res.HallCommentMainApiModelList;
          if (dataList.length <= 0) {
            that.finished = true;
          }

          if (dataList.length < 10){
            that.finished = true;
          }

          if (this.options.pageIndex > 1) {
            if (dataList.length > 0) {
              dataList.forEach(element => {
                that.dataList.push(element);
              });
            }
          } 
          else {
            that.dataList = dataList;
          }
        },
        error => {}
      );
    }
  },
  created() {
    var that = this;
    that.init();
  }

};
</script>

<style scoped>
.rich>>> img{ max-width: 100%}
</style>
